var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from "@angular/core";
import { ColorCodeService } from "../../../services/color-code.service";
import { UserService } from "../../../services/user.service";
import { CardComponent } from "../card.component";
var CollectionCardComponent = /** @class */ (function (_super) {
    __extends(CollectionCardComponent, _super);
    function CollectionCardComponent(colorCodeService, userService) {
        var _this = _super.call(this, colorCodeService, userService) || this;
        _this.colorCodeService = colorCodeService;
        _this.userService = userService;
        return _this;
    }
    CollectionCardComponent.prototype.ngOnInit = function () {
        this.showAsCollection = true;
    };
    return CollectionCardComponent;
}(CardComponent));
export { CollectionCardComponent };
